import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import React from "react";
import linkIcon from "../../../../assets/images/sub/purchase_voucher/link_icon.svg";
import {useUserAgent} from "../../../../hooks/hooks";

interface Args {
    isAgreed: boolean;
    onClickAgreeBtn: (_: boolean) => void
    onClickTermsLink: (_: React.MouseEvent) => void
}

export function AgreementField({isAgreed, onClickAgreeBtn, onClickTermsLink}: Args) {
    const {isMobile} = useUserAgent();
    return (
        isMobile ? (
            <div className={`${style.agreement} ${style.mobile}`}>
                <div className={style.checkBtnWrap}>
                    <button
                        className={`${style.checkBtn} ${isAgreed ? style.checked : ""}`}
                        onClick={() => onClickAgreeBtn(isAgreed)}
                    />
                </div>
                <div className={style.textWrap}>
                    <span className={style.text}>위 주문내용 확인 및 결제약관, 결제 진행에 동의합니다.</span>
                    <div className={style.linkWrap}>
                <span className={style.link} onClick={onClickTermsLink}>
                  자세히보기
                </span>
                        <img src={linkIcon} alt={"자세히 보기 아이콘"}/>
                    </div>
                </div>
            </div>
        ) : (
            <div className={`${style.agreement} ${style.desktop}`}>
                <button
                    className={`${style.checkBtn} ${isAgreed ? style.checked : ""}`}
                    onClick={() => onClickAgreeBtn(isAgreed)}
                />
                <span className={style.text}>위 주문내용 확인 및 결제약관, 결제 진행에 동의합니다.</span>
                <span className={style.link} onClick={onClickTermsLink}>
              자세히보기
            </span>
            </div>

        )
    )
}